export default __webpack_public_path__ + "static/media/lisieux10.8d450ea8.jpg";